import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CardComponent } from '../../@theme/components/card/card.component';
import { AnyObject } from '@mri/types';
import { storageManager } from '@mri/constants';
import { MatSnackBar } from '@angular/material/snack-bar';

interface ClipboardData {
  namespace: string;
  data: AnyObject;
  copedTime: Date;
}

@Component({
  selector: 'app-clipboard-pane',
  standalone: true,
  imports: [
    MatButtonModule,
    CardComponent
  ],
  templateUrl: './clipboard-pane.component.html',
  styleUrl: './clipboard-pane.component.scss'
})
export class ClipboardPaneComponent implements OnInit {
  haveClipboard: boolean;

  @Input({ required: true })
  namespace: string;

  @Input()
  value: AnyObject;

  @Output()
  valueChange = new EventEmitter<AnyObject>();

  constructor(
    private _snackBar: MatSnackBar

  ) {

  }


  ngOnInit() {
    const { namespace } = this;

    const { data, copedTime } = storageManager.getJson<ClipboardData>(`copy.${namespace}`) || {};
    if (!data) return;

    const now = new Date();
    const coped = new Date(copedTime || '');

    if (now.getTime() - coped.getTime() > 1000 * 60 * 15) return;

    this.haveClipboard = true;
  }

  onCopy() {
    const data = (this.value || {});
    const { namespace } = this;

    storageManager.set(`copy.${namespace}`, {
      copedTime: new Date(),
      namespace,
      data
    });

    this._snackBar.open('Datos copados correctamente en portapapeles!')
  }

  onPaste() {
    const { namespace } = this;
    const { data } = storageManager.getJson<ClipboardData>(`copy.${namespace}`) || {};
    if (!data) return;

    this.valueChange.next(data);
  }
}
